import {
    AfterViewInit,
    Component,
    ChangeDetectionStrategy,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation,
    AfterViewChecked
} from '@angular/core';
import { MotorsDraftFacade, RouterFacade } from '@classifieds-sell/state';
import { StepIds } from 'libs/motors-ui/src/lib/models/motors-step/motors-step-model';
import { MotorsPageBase } from '../../../motors-page-base';
import { MotorsAcceptedPaymentsSectionComponent } from 'libs/motors-ui/src/lib/sections/listing-details/motors-accepted-payments-section.component';
import { MotorsEndingDateTimeSectionComponent } from 'libs/motors-ui/src/lib/sections/listing-details/motors-ending-datetime-section.component';
import { MotorsAuctionPricingSectionComponent } from 'libs/motors-ui/src/lib/sections/listing-details/motors-auction-pricing-section.component';
import { MotorsVehicleTransferOptionsSectionComponent } from 'libs/motors-ui/src/lib/sections/listing-details/motors-vehicle-transfer-options-section.component';
import { MotorsListingDetailsHeaderSectionComponent } from 'libs/motors-ui/src/lib/sections/motors-listing-details-header-section/motors-listing-details-header-section.component';
import { MotorsClassifiedPricingSectionComponent } from 'libs/motors-ui/src/lib/sections/listing-details/motors-classified-pricing-section.component';
import { MotorsListingDetailsContactSectionComponent } from 'libs/motors-ui/src/lib/sections/motors-listing-details-contact-section/motors-listing-details-contact-section.component';
import { SellingTypeEnum } from '@classifieds-sell/datalayer';
import { MotorsListingDetailsPackageSectionComponent } from 'libs/motors-ui/src/lib/sections/motors-listing-details-package-section/motors-listing-details-package-section.component';
import { from } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './motors-listing-details-page.component.html',
    styleUrls: ['./motors-listing-details-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BoatsAndMarineListingDetailsPageComponent
    extends MotorsPageBase
    implements AfterViewInit, OnInit, OnDestroy, AfterViewChecked {
    SellingTypeEnum = SellingTypeEnum;
    isHideMotorsListingDetailsHeaderSectionComponent = false;

    @ViewChild(MotorsListingDetailsHeaderSectionComponent, {
        read: MotorsListingDetailsHeaderSectionComponent
    })
    motorsListingDetailsHeaderSectionComponent: MotorsListingDetailsHeaderSectionComponent;

    @ViewChild(MotorsAcceptedPaymentsSectionComponent, {
        read: MotorsAcceptedPaymentsSectionComponent
    })
    motorsAcceptedPaymentsSectionComponent: MotorsAcceptedPaymentsSectionComponent;

    @ViewChild(MotorsEndingDateTimeSectionComponent, {
        read: MotorsEndingDateTimeSectionComponent
    })
    motorsEndingDateTimeSectionComponent: MotorsEndingDateTimeSectionComponent;

    @ViewChild(MotorsAuctionPricingSectionComponent, {
        read: MotorsAuctionPricingSectionComponent
    })
    motorsAuctionPricingSectionComponent: MotorsAuctionPricingSectionComponent;

    @ViewChild(MotorsVehicleTransferOptionsSectionComponent, {
        read: MotorsVehicleTransferOptionsSectionComponent
    })
    motorsVehicleTransferOptionsSectionComponent: MotorsVehicleTransferOptionsSectionComponent;

    @ViewChild(MotorsClassifiedPricingSectionComponent, {
        read: MotorsClassifiedPricingSectionComponent
    })
    motorsClassifiedPricingSectionComponent: MotorsClassifiedPricingSectionComponent;

    @ViewChild(MotorsListingDetailsContactSectionComponent, {
        read: MotorsListingDetailsContactSectionComponent
    })
    motorsListingDetailsContactSectionComponent: MotorsListingDetailsContactSectionComponent;

    @ViewChild(MotorsListingDetailsPackageSectionComponent, {
        read: MotorsListingDetailsPackageSectionComponent
    })
    motorsListingDetailsPackageSectionComponent: MotorsListingDetailsPackageSectionComponent;

    constructor(draftFacade: MotorsDraftFacade, routerFacade: RouterFacade) {
        super(StepIds.listingDetails, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
        from(this.routerFacade.isEditOrRelistPage$)
            .pipe(takeUntil(this._destroyed$))
            .subscribe((isEditOrRelistPage: boolean) => {
                this.isHideMotorsListingDetailsHeaderSectionComponent = isEditOrRelistPage;
            });
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewChecked() {
        // conditional section registration based on the selling type
        // only register sections that require validation
        if (
            this.draftState.draftData.listingDetails.sellingType ===
            SellingTypeEnum.auction
        ) {
            super.registerSection(this.motorsAcceptedPaymentsSectionComponent);
            super.registerSection(this.motorsAuctionPricingSectionComponent);
            super.registerSection(
                this.motorsVehicleTransferOptionsSectionComponent
            );

            // classifieds
            super.unregisterSection(
                this.motorsClassifiedPricingSectionComponent
            );
        } else {
            // auctions
            super.unregisterSection(
                this.motorsAcceptedPaymentsSectionComponent
            );
            super.unregisterSection(this.motorsAuctionPricingSectionComponent);
            super.unregisterSection(
                this.motorsVehicleTransferOptionsSectionComponent
            );

            // classifieds
            super.registerSection(this.motorsClassifiedPricingSectionComponent);
        }
    }

    ngAfterViewInit() {
        // sections that are always shown regardless of the selling type
        super.registerSection(this.motorsListingDetailsHeaderSectionComponent);
        super.registerSection(this.motorsEndingDateTimeSectionComponent);
        super.registerSection(this.motorsListingDetailsContactSectionComponent);
        super.registerSection(this.motorsListingDetailsPackageSectionComponent);
    }
}
